import React, { createRef, forwardRef, useCallback, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { classNames } from 'primereact/utils';
import { Ripple } from 'primereact/ripple';
import { Badge } from 'primereact/badge';
import { connect } from 'react-redux';
import withRouter from './components/lib/withRouter';
import Authentication from './components/session/index';

const AppSubmenu = forwardRef((props, ref) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const onMenuItemClick = (event, item, index) => {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
            event.preventDefault();
        }
        if (item.items) {
            event.preventDefault();
        }
        if (props.root) {
            props.onRootMenuitemClick({
                originalEvent: event
            });
        }
        if (item.items) {
            setActiveIndex(index === activeIndex ? null : index);
        }

        props.onMenuitemClick({
            originalEvent: event,
            item: item
        });
    };

    const onMenuItemMouseEnter = (index) => {
        if (props.root && props.menuActive && (props.menuMode === 'slim' || props.menuMode === 'horizontal') && !isMobile()) {
            setActiveIndex(index);
        }
    };

    const visible = (item) => {
        return typeof item.visible === 'function' ? item.visible() : item.visible !== false;
    };

    const isMobile = () => {
        return window.innerWidth <= 1091;
    };

    const isSlim = useCallback(() => {
        return props.menuMode === 'slim';
    }, [props.menuMode]);

    const isHorizontal = useCallback(() => {
        return props.menuMode === 'horizontal';
    }, [props.menuMode]);

    const getLink = (item, index) => {
        // const menuitemIconClassName = classNames('layout-menuitem-icon', item.icon);

        const menuitemIconClassName = classNames('layout-menuitem-icon', typeof item.icon === 'string' ? item.icon : '');

        // Check if icon is a React component or a string
        const iconElement = typeof item.icon === 'string'
            ? <i className={menuitemIconClassName}></i>
            : React.isValidElement(item.icon)
                ? <span className="layout-menuitem-icon" style={{ display: 'inline-flex', alignItems: 'center', width: '16px', height: '16px' }}>
                    <svg width="16" height="16" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.2372 3.28849L10.2372 0.288493C10.0832 0.237169 9.91677 0.237169 9.76281 0.288493L0.762812 3.28849C0.613473 3.33828 0.483585 3.43379 0.391547 3.5615C0.299509 3.68921 0.249988 3.84264 0.25 4.00006V11.5001C0.25 11.699 0.329018 11.8897 0.46967 12.0304C0.610322 12.171 0.801088 12.2501 1 12.2501C1.19891 12.2501 1.38968 12.171 1.53033 12.0304C1.67098 11.8897 1.75 11.699 1.75 11.5001V5.04068L4.89906 6.08974C4.0624 7.44143 3.79634 9.06991 4.15931 10.6176C4.52229 12.1653 5.48462 13.5057 6.835 14.3444C5.1475 15.0063 3.68875 16.2035 2.62187 17.8404C2.56639 17.9228 2.52785 18.0155 2.50849 18.113C2.48914 18.2105 2.48936 18.3109 2.50913 18.4083C2.52891 18.5057 2.56785 18.5982 2.62369 18.6804C2.67953 18.7626 2.75116 18.8329 2.83441 18.8872C2.91766 18.9415 3.01087 18.9787 3.10863 18.9967C3.20639 19.0147 3.30674 19.013 3.40386 18.9918C3.50097 18.9707 3.59291 18.9304 3.67433 18.8734C3.75575 18.8164 3.82502 18.7438 3.87813 18.6597C5.29094 16.4922 7.52219 15.2501 10 15.2501C12.4778 15.2501 14.7091 16.4922 16.1219 18.6597C16.2319 18.8232 16.4018 18.9369 16.5949 18.9761C16.788 19.0153 16.9888 18.9769 17.1539 18.8693C17.3189 18.7616 17.435 18.5933 17.4769 18.4008C17.5189 18.2083 17.4834 18.0069 17.3781 17.8404C16.3112 16.2035 14.8469 15.0063 13.165 14.3444C14.5141 13.5057 15.4755 12.1662 15.8384 10.6196C16.2013 9.07308 15.9361 7.44572 15.1009 6.09443L19.2372 4.71631C19.3866 4.66655 19.5165 4.57105 19.6086 4.44334C19.7006 4.31563 19.7502 4.16218 19.7502 4.00474C19.7502 3.8473 19.7006 3.69386 19.6086 3.56615C19.5165 3.43843 19.3866 3.34294 19.2372 3.29318V3.28849ZM14.5 9.25006C14.5002 9.96148 14.3317 10.6628 14.0084 11.2965C13.6851 11.9302 13.2161 12.4782 12.6399 12.8956C12.0638 13.313 11.3969 13.5878 10.694 13.6975C9.99107 13.8072 9.27216 13.7487 8.59623 13.5268C7.92031 13.3048 7.30663 12.9258 6.80555 12.4208C6.30448 11.9158 5.93028 11.2991 5.71367 10.6215C5.49705 9.94384 5.44419 9.22449 5.55942 8.52246C5.67465 7.82042 5.95469 7.15572 6.37656 6.58287L9.76281 7.70787C9.91677 7.75919 10.0832 7.75919 10.2372 7.70787L13.6234 6.58287C14.1932 7.35536 14.5005 8.29015 14.5 9.25006Z" fill="#495057" />
                    </svg>
                </span>
                : typeof item.icon === 'function'
                    ? <span className="layout-menuitem-icon" style={{ display: 'inline-flex', alignItems: 'center', width: '16px', height: '16px' }}>
                        <svg width="16" height="16" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.2372 3.28849L10.2372 0.288493C10.0832 0.237169 9.91677 0.237169 9.76281 0.288493L0.762812 3.28849C0.613473 3.33828 0.483585 3.43379 0.391547 3.5615C0.299509 3.68921 0.249988 3.84264 0.25 4.00006V11.5001C0.25 11.699 0.329018 11.8897 0.46967 12.0304C0.610322 12.171 0.801088 12.2501 1 12.2501C1.19891 12.2501 1.38968 12.171 1.53033 12.0304C1.67098 11.8897 1.75 11.699 1.75 11.5001V5.04068L4.89906 6.08974C4.0624 7.44143 3.79634 9.06991 4.15931 10.6176C4.52229 12.1653 5.48462 13.5057 6.835 14.3444C5.1475 15.0063 3.68875 16.2035 2.62187 17.8404C2.56639 17.9228 2.52785 18.0155 2.50849 18.113C2.48914 18.2105 2.48936 18.3109 2.50913 18.4083C2.52891 18.5057 2.56785 18.5982 2.62369 18.6804C2.67953 18.7626 2.75116 18.8329 2.83441 18.8872C2.91766 18.9415 3.01087 18.9787 3.10863 18.9967C3.20639 19.0147 3.30674 19.013 3.40386 18.9918C3.50097 18.9707 3.59291 18.9304 3.67433 18.8734C3.75575 18.8164 3.82502 18.7438 3.87813 18.6597C5.29094 16.4922 7.52219 15.2501 10 15.2501C12.4778 15.2501 14.7091 16.4922 16.1219 18.6597C16.2319 18.8232 16.4018 18.9369 16.5949 18.9761C16.788 19.0153 16.9888 18.9769 17.1539 18.8693C17.3189 18.7616 17.435 18.5933 17.4769 18.4008C17.5189 18.2083 17.4834 18.0069 17.3781 17.8404C16.3112 16.2035 14.8469 15.0063 13.165 14.3444C14.5141 13.5057 15.4755 12.1662 15.8384 10.6196C16.2013 9.07308 15.9361 7.44572 15.1009 6.09443L19.2372 4.71631C19.3866 4.66655 19.5165 4.57105 19.6086 4.44334C19.7006 4.31563 19.7502 4.16218 19.7502 4.00474C19.7502 3.8473 19.7006 3.69386 19.6086 3.56615C19.5165 3.43843 19.3866 3.34294 19.2372 3.29318V3.28849ZM14.5 9.25006C14.5002 9.96148 14.3317 10.6628 14.0084 11.2965C13.6851 11.9302 13.2161 12.4782 12.6399 12.8956C12.0638 13.313 11.3969 13.5878 10.694 13.6975C9.99107 13.8072 9.27216 13.7487 8.59623 13.5268C7.92031 13.3048 7.30663 12.9258 6.80555 12.4208C6.30448 11.9158 5.93028 11.2991 5.71367 10.6215C5.49705 9.94384 5.44419 9.22449 5.55942 8.52246C5.67465 7.82042 5.95469 7.15572 6.37656 6.58287L9.76281 7.70787C9.91677 7.75919 10.0832 7.75919 10.2372 7.70787L13.6234 6.58287C14.1932 7.35536 14.5005 8.29015 14.5 9.25006Z" fill="#495057" />
                        </svg>
                    </span>
                    : <i className={menuitemIconClassName}></i>;

        const content = (
            <>
                {iconElement}
                <span className="layout-menuitem-text">{item.label}</span>
                {item.items && <i className="pi pi-fw pi-angle-down layout-submenu-toggler"></i>}
                {item.badge && <Badge value={item.badge} style={{ height: '100%' }} />}
                <Ripple />
            </>
        );
        const commonLinkProps = {
            style: item.style,
            className: classNames(item.className, 'p-ripple', { 'p-disabled': item.disabled, 'p-link': !item.to }),
            target: item.target,
            onClick: (e) => {
                // console.log('props?.logoSquare?.storageLocation.length  ', props?.logoSquare?.storageLocation)
                // if (props?.logoSquare?.storageLocation.length) {
                onMenuItemClick(e, item, index)
                // }
            }
        };

        if (item.url) {
            return (
                <a href={item.url} rel="noopener noreferrer" {...commonLinkProps}>
                    {content}
                </a>
            );
        } else if (item.image) {
            return (
                <div className='flex justify-content-center'>
                    <img src={localStorage.getItem('logoRectangle')} alt='logo' width={'100px'} />
                </div>
            )
        } else if (!item.to) {
            return (
                (item.items ? <button type="button" {...commonLinkProps}>
                    {content}
                </button> : <div style={{ fontSize: '10px', marginLeft: '1px', marginBottom: '15px' }}>{content}</div>)
            );
        }

        return (
            <NavLink to={item.to} {...commonLinkProps} className={({ isActive }) => classNames(commonLinkProps.className, isActive ? 'active-route' : undefined)}>
                {content}
            </NavLink>
        );
    };

    const isMenuActive = (item, index) => {
        return item.items && (props.root && (!isSlim() || (isSlim() && (props.mobileMenuActive || activeIndex !== null))) ? true : activeIndex === index);
    };

    const getItems = () => {
        const transitionTimeout = props.mobileMenuActive ? 0 : isSlim() && props.root ? { enter: 400, exit: 400 } : props.root ? 0 : { enter: 1000, exit: 450 };
        return props.items.map((item, i) => {
            if (visible(item)) {
                if (!item.separator) {
                    const submenuRef = createRef();
                    const menuitemClassName = classNames({ 'layout-root-menuitem': props.root, 'active-menuitem': activeIndex === i && !item.disabled });
                    const link = getLink(item, i);
                    const rootMenuItem = props.root && (
                        <div className="layout-root-menuitem">
                            <div className="layout-menuitem-root-text" style={{ textTransform: 'uppercase' }}>
                                {item.label}
                            </div>
                        </div>
                    );

                    const handleSubmenuEntered = () => {
                            if (isSlim() && props.root && submenuRef.current) {
                                const el = submenuRef.current;
                                const adjustPosition = () => {
                                    if (!el) return;
                                    el.style.marginTop = '';
                                    const rect = el.getBoundingClientRect();
                                    const overflow = rect.bottom - window.innerHeight;
                                    if (overflow > 0) {
                                        el.style.marginTop = `-${overflow + 8}px`;
                                    }
                                };
                                adjustPosition();
                                const ro = new ResizeObserver(adjustPosition);
                                ro.observe(el);
                                setTimeout(() => ro.disconnect(), 10000);
                            }
                        };

                    return (
                        <li key={item.label || i} className={menuitemClassName} role="menuitem">
                            {link}
                            {rootMenuItem}
                            <CSSTransition nodeRef={submenuRef} classNames="layout-menu" timeout={transitionTimeout} in={isMenuActive(item, i)} unmountOnExit onEntered={handleSubmenuEntered}>
                                <AppSubmenu ref={submenuRef} items={visible(item) && item.items} menuActive={props.menuActive} menuMode={props.menuMode} parentMenuItemActive={activeIndex === i} onMenuitemClick={props.onMenuitemClick}></AppSubmenu>
                            </CSSTransition>
                        </li>
                    );
                } else {
                    return <li className="menu-separator" style={item.style} key={`separator${i}`} role="separator"></li>;
                }
            }

            return null;
        });
    };

    useEffect(() => {
        if (!props.menuActive && isSlim()) {
            setActiveIndex(null);
        }
    }, [props.menuActive, isSlim]);

    useEffect(() => {
        if (!props.menuActive && isHorizontal()) {
            setActiveIndex(null);
        }
    }, [props.menuActive, isHorizontal]);

    if (!props.items) {
        return null;
    }

    const items = getItems();
    return (props.menuActive && props.root) ? (
        <ul ref={ref} className="layout-menu" style={{ backgroundColor: 'white', zIndex: 10, position: 'fixed', minHeight: '100vh', maxWidth: '190px' }} role="menu">
            {items}
        </ul>
    ) : (
        <ul ref={ref} className={`layout-menu`} role="menu">
            {items}
        </ul>
    );
});
const mapStateToProps = (state) => ({
    logoSquare: state.orgData.logoSquare,
});
export default connect(mapStateToProps, {})(Authentication(withRouter(AppSubmenu)));

